import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExamSubjectGradepointsPopComponent } from '../exam-subject-gradepoints-pop/exam-subject-gradepoints-pop.component';
import { ExamSubjectPopupComponent } from '../exam-subject-popup/exam-subject-popup.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-generate-roll-no-po-p',
  templateUrl: './generate-roll-no-po-p.component.html',
  styleUrls: ['./generate-roll-no-po-p.component.scss']
})
export class GenerateRollNoPoPComponent implements OnInit {

  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private elRef: ElementRef,
    public dialogRef: MatDialogRef<ExamSubjectPopupComponent>,
    public dialogRefGradePoints: MatDialogRef<ExamSubjectGradepointsPopComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ){ }

  ngOnInit(): void {
  }

}
